import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import { styled } from "@mui/system";
const CustomTextField = styled(TextField)`
  .icon {
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
`;
const CustomText_input = ({
  icon,
  placeholder,
  Value,
  HandleInput,
  name,
  inputType,
  height,
  StartIcon,
  iconClick,
  className,
  disabled,
  readOnly,
  maxLength,
  Value1,
  iconColor,
  // isBorder,
  isPast,
  fontSize,
  isFuture,
}) => {
  const enforceMaxLength = (event) => {
    const input = event.target;
    const inputValue = input.value;

    // Apply maxLength validation
    if (maxLength && inputValue.length > maxLength) {
      input.value = inputValue.slice(0, maxLength);
    }
  };

  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
  const handleKeyDown = (event) => {
    // Preventing the default behavior of arrow down key
    if (event.key === "ArrowDown" ||event.key === "ArrowUp") {
      event.preventDefault();
    }
  };


  return inputType == "date" ? (
    <div className="date-input-container wrapper ">
      <input
        type="date"
        style={{
          height: height ? height : "50px",
          width: "100%",
          borderRadius: "11px",
          border: "1px solid #5F4C3E",
          padding: "3%",
          colorScheme: "dark",
        }}
        placeholder={placeholder ? placeholder : "MM/DD/YYYY"}
        min={isPast ? today : ""}
        max={isFuture ? today : ""}
        value={Value}
        onChange={(e) => HandleInput(e.target.value, name)}
      />
      <span></span>
    </div>
  ) : (
    <CustomTextField
      fullWidth
      placeholder={placeholder}
      disabled={disabled}
      autoHighlight={false}
      inputProps={{
        maxLength: maxLength ? maxLength : 250,
        readOnly: readOnly,
        inputMode: inputType,
        onKeyDown: handleKeyDown,
        // onkeyup: handleKeyUp,
        min: inputType == "date" ? new Date().toISOString().slice(0, 16) : 0,
      }}
      className={`${className}"customInput label"`}
      type={inputType ? inputType : "text"}
      sx={{
        "& .MuiOutlinedInput-root": {
          height: height ? height : "50px",
          fontFamily: "PoppinsMedium",
          fontSize: fontSize ? fontSize : "clamp(10px, 4vw, 13px)",
          color: "#FFF",
          backgroundColor: "rgba(0, 0, 0, 0.23)", // Change to transparent
          borderRadius: "11px",
          borderColor: "#5F4C3E",
          border: "1px solid #5F4C3E",
          colorScheme: "dark",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "#fff", // Border color on focus
            backgroundColor: "transparent", // Background color on focus
            color: "#fff !important",
          },
        borderRadius: "10px",
        color: "#fff",
        borderColor: "#5F4C3E",
        "input::-webkit-inner-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
          color: "#FFF",
        },
        "& input::placeholder": {
          color: "#FFFF",
        },
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: "#ccc", // Change the font color here
        },
      }}
      value={Value}
      defaultValue={Value1}
      onWheel={(e) => e.target.blur()}
      onChange={(e) => HandleInput(e.target.value, name)}
      onInput={enforceMaxLength}
      autoComplete={"off"}
      min={isPast ? today : undefined} // Set min attribute to today's date if isPast is true
      InputProps={{
        endAdornment: icon ? (
          <InputAdornment position="end">
            <button
              onClick={iconClick}
              // onMouseDown={iconClick}
              className="btn btn-0 border-0 "
              // edge="end"
            >
              {icon && (
                <span
                  className="icon text-center mx-auto"
                  style={{ color: iconColor ? iconColor : "#000" }}
                >
                  {icon}
                </span>
              )}
            </button>
          </InputAdornment>
        ) : (
          ""
        ),
        startAdornment: (
          <InputAdornment position="start">
            {StartIcon && (
              <span
                className="icon"
                style={{ color: iconColor ? iconColor : "#000" }}
              >
                {StartIcon}
              </span>
            )}{" "}
          </InputAdornment>
        ),
      }}
    />
  );
};

export default CustomText_input;
